var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.643 17.643C28.9447 16.3412 31.0553 16.3412 32.357 17.643L52.357 37.643C53.6588 38.9447 53.6588 41.0553 52.357 42.357L32.357 62.357C31.0553 63.6588 28.9447 63.6588 27.643 62.357C26.3413 61.0553 26.3413 58.9447 27.643 57.643L45.286 40L27.643 22.357C26.3413 21.0553 26.3413 18.9447 27.643 17.643Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.9c8d9dc46b488813184f90dfee3dc2dd.svg";
export { ForwardRef as ReactComponent };